import React from "react";
import hero from "../../assets/blue-rolls-royce-wraith-side-view-i7lepaqv9ujm9k9q.png";

const HeroSection = () => {
  return (
    <>
      <div
        className="bg-sky-500 text-white text-center pl-4 sm:pl-8 md:pl-12"
        style={{
          fontFamily: "Built Titling",
          textShadow: "0px 16px 18.2px rgba(0, 0, 0, 0.25)",
        }}
      >
        <div className="flex flex-col items-center gap-4 sm:gap-6 md:gap-8">
          <p className="text-center text-white font-bold leading-tight sm:leading-[110%] md:leading-[126%] text-4xl sm:text-5xl md:text-6xl lg:text-8xl pt-3">
            FIND YOUR IDEAL RIDE OR
            <span>
              <br />
              SALE CONFIDENTLY
            </span>
          </p>
          <img
            src={hero}
            alt="hero"
            loading="lazy"
            className="w-full mt-[-25px] md:mt-[-35px] pb-3"
          />
        </div>
      </div>
    </>
  );
};

export default HeroSection;
